import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    DateTimeColumn,
    ExternalDespatchLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'History',
      columns: [
        new TextColumn('Outbound Operator', 'outboundOperator').withWidth(100),
        new TextColumn('Outbound IMPC', 'outboundImpc').withWidth(100),
        new TextColumn('Inbound Operator', 'inboundOperator').withWidth(100),
        new TextColumn('Inbound IMPC', 'inboundImpc').withWidth(100),
        new DateTimeColumn('Departure date & time', 'departureDateTime').withWidth(140),
        new DateTimeColumn('Arrival date & time', 'arrivalDateTime').withWidth(140),
        new NonZeroNumberColumn('Pre-advised Quantity ', 'quantityPreAdvised'),
        new NonZeroNumberColumn('Objected Quantity', 'quantityObjected'),
        new NonZeroNumberColumn('Confirmed Quantity', 'quantityConfirmed'),
        new TextColumn('Who', 'lastUpdateUser'),
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'despatchId').withWidth(215)),
        new TextColumn('Status', 'status'),
        new TextColumn('Comments', 'comment'),
        new NonZeroNumberColumn('ID', 'id'),
        new DateTimeColumn('Last Update Date', 'lastUpdateDate').withWidth(140),
        new DateTimeColumn('Loading date & time ', 'loadingDateTime'),
        new TextColumn('Transport Duration', 'transportDuration'),
        new TextColumn('Message Delay', 'messageDelay'),
        new TextColumn('Age', 'age'),
      ],
    },
  ];
};
